/**
 * <s-mega-menu> — click-to-open image panel for a top-level menu item.
 * Toggles data-open on the host (CSS reveals the panel) and keeps the button's
 * aria-expanded in sync. Closes on outside click, Escape (returning focus to
 * the toggle), or when another mega menu opens.
 */
class SMegaMenu extends HTMLElement {
  connectedCallback() {
    this.toggleButton = this.querySelector('[data-mega-toggle]');
    if (!this.toggleButton) return;

    this.handleToggle = () => (this.hasAttribute('data-open') ? this.close() : this.open());
    this.handleDocumentClick = (event) => {
      if (!this.contains(event.target)) this.close();
    };
    this.handleKeydown = (event) => {
      if (event.key === 'Escape' && this.hasAttribute('data-open')) {
        this.close();
        this.toggleButton.focus();
      }
    };

    this.toggleButton.addEventListener('click', this.handleToggle);
    document.addEventListener('click', this.handleDocumentClick);
    document.addEventListener('keydown', this.handleKeydown);
  }

  disconnectedCallback() {
    this.toggleButton?.removeEventListener('click', this.handleToggle);
    document.removeEventListener('click', this.handleDocumentClick);
    document.removeEventListener('keydown', this.handleKeydown);
  }

  open() {
    document.querySelectorAll('s-mega-menu[data-open]').forEach((menu) => {
      if (menu !== this) menu.close();
    });
    this.setAttribute('data-open', '');
    this.toggleButton.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.removeAttribute('data-open');
    this.toggleButton?.setAttribute('aria-expanded', 'false');
  }
}

if (!customElements.get('s-mega-menu')) {
  customElements.define('s-mega-menu', SMegaMenu);
}
